import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchAlternate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "search-alternate_icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m23.384 21.619-6.529-6.529a9.284 9.284 0 1 0-1.768 1.768l6.529 6.529a1.266 1.266 0 0 0 1.768 0 1.25 1.25 0 0 0 0-1.768M2.75 9.5a6.75 6.75 0 1 1 6.75 6.75A6.76 6.76 0 0 1 2.75 9.5" })
});
export { SvgSearchAlternate as ReactComponent };
